import React, { Component } from "react";
import Slider from "react-slick";
import moment from "moment";
import Loader from "./../../../common/loader";
import { getNewsListing } from "./../../../../services/newsListingService";

const LeftArrow = ({ className, style, onClick }) => {
  return (
    <button
      className={`left-arrow`}
      onClick={onClick}
      style={{
        ...style
      }}
    >
      <i
        style={{ fontSize: 20, color: "#A7A7A7" }}
        className="fa fa-long-arrow-left"
      />
    </button>
  );
};

const RightArrow = ({ className, style, onClick }) => {
  return (
    <button
      className={`right-arrow`}
      onClick={onClick}
      style={{
        ...style
      }}
    >
      <i
        style={{ fontSize: 20, color: "#A7A7A7" }}
        className="fa fa-long-arrow-right"
      />
    </button>
  );
};

class NewsTemplate extends Component {
  state = {
    newsList: [],
    loading: true
  };

  async componentDidMount() {
    const { data } = await getNewsListing();
    this.setState({ newsList: data, loading: false });
  }

  render() {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <RightArrow />,
      prevArrow: <LeftArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    if (this.state.loading) return <Loader />;
    return (
      <Slider {...settings}>
        {this.state.newsList.map(news => (
          <div className="col" key={news.id}>
            <div
              className="news-column p-3"
              style={{
                background: "var(--cardBg)",
                border: "var(--card-border)",
                transition: "color 0.2s ease-out, background 0.2s ease-out"
              }}
            >
              <div className="news-inner-col d-flex justify-content-between mb-3">
                <span className="badge badge-warning news-bedge">
                  {news.categories.map(category => category.name)}
                </span>
                <img
                  className="img-fluid"
                  src={require("../../../../assets/icons/share-icon.svg")}
                  alt="share"
                />
              </div>
              <div className="row">
                <div className="col-8">
                  <h3
                    className="news-col-heading text-left"
                    style={{
                      color: "var(--h3Color)",
                      transition:
                        "color 0.2s ease-out, background 0.2s ease-out"
                    }}
                  >
                    {news.headline}
                  </h3>
                </div>
                <div className="col-4 p-0 pt-2">
                  <p className="post-publish-time">
                    {moment(news.createdAt).fromNow()}
                  </p>
                </div>
              </div>

              <div className="news-inner-col d-flex justify-content-between">
                <span
                  className="news-source"
                  style={{
                    color: "var(--pDescColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  Source :{" "}
                  <a
                    href={news.source.url}
                    target="_blank"
                    className="span-source"
                  >
                    {news.source.title}
                  </a>
                </span>
              </div>

              <div className="price-div mt-4">
                <p
                  className="main-para-news text-left"
                  style={{
                    color: "var(--pColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  {news.text}
                </p>
              </div>
              <p className="news-gram text-right">
                {news.tags.map(tagname => "#" + tagname.tag)}
              </p>
            </div>
          </div>
        ))}
      </Slider>
    );
  }
}

export default NewsTemplate;
